import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import { Skeleton } from '@node-space/storybook-components/dist/SkeletonLoader'
import { Box } from '@node-space/ui-components'

export const CustomerInfoSkeletonLoader = () => {
  return (
    <Box flexCol padding={16} gap={32} width="full">
      <Skeleton variant="title" className="w-2/3" />
      <Box flexCol align="center" gapY={12}>
        <Skeleton variant="button" isIcon />
        <Skeleton variant="title" className="w-1/2" />
      </Box>
      {[...Array(3)]?.map(() => (
        <Box key={uuidv4()} flexCol gap={8}>
          <Skeleton className="w-3/5" />
          <Skeleton className="w-2/5" />
        </Box>
      ))}
    </Box>
  )
}
